import { render, staticRenderFns } from "./messagesendgroupdetail.vue?vue&type=template&id=4f91a164&"
import script from "./messagesendgroupdetail.vue?vue&type=script&lang=ts&"
export * from "./messagesendgroupdetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "messagesendgroupdetail.vue"
export default component.exports